if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Hammock Hut: refined desktop navigation for product media galleries. */
(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const styleId = 'hh-product-gallery-navigation-styles';

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .hh-product-gallery-nav { display: none; }

      @media screen and (min-width: 750px) {
        media-gallery [id^="GalleryViewer"] {
          position: relative;
        }

        .hh-product-gallery-nav {
          position: absolute;
          inset: 0;
          z-index: 4;
          display: block;
          pointer-events: none;
        }

        .hh-product-gallery-nav__button {
          position: absolute;
          bottom: 1.8rem;
          width: 4.2rem;
          height: 4.2rem;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(255, 255, 255, 0.58);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.72);
          color: rgba(24, 24, 24, 0.82);
          box-shadow: 0 0.3rem 1.5rem rgba(0, 0, 0, 0.12);
          -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
          cursor: pointer;
          pointer-events: auto;
          opacity: 0.9;
          transition: background 160ms ease, box-shadow 160ms ease, opacity 160ms ease, transform 160ms ease;
        }

        .hh-product-gallery-nav__button--previous { left: 1.8rem; }
        .hh-product-gallery-nav__button--next { right: 1.8rem; }

        .hh-product-gallery-nav__button svg {
          width: 1.8rem;
          height: 1.8rem;
          display: block;
          fill: none;
          stroke: currentColor;
          stroke-width: 1.8;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .hh-product-gallery-nav__button:hover {
          background: rgba(255, 255, 255, 0.92);
          box-shadow: 0 0.45rem 1.8rem rgba(0, 0, 0, 0.16);
          opacity: 1;
          transform: translateY(-1px);
        }

        .hh-product-gallery-nav__button:focus-visible {
          outline: 2px solid rgba(255, 255, 255, 0.95);
          outline-offset: 3px;
          opacity: 1;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .hh-product-gallery-nav__button { transition: none; }
        .hh-product-gallery-nav__button:hover { transform: none; }
      }
    `;
    document.head.appendChild(style);
  }

  const createButton = (direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `hh-product-gallery-nav__button hh-product-gallery-nav__button--${direction}`;
    button.dataset.hhGalleryDirection = direction;
    button.setAttribute('aria-label', direction === 'next' ? 'Next product image' : 'Previous product image');
    button.innerHTML = direction === 'next'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"></path></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"></path></svg>';
    return button;
  };

  const initializeGallery = (gallery) => {
    if (!gallery || gallery.dataset.hhDesktopGalleryNav === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const mediaItems = Array.from(viewer.querySelectorAll('[data-media-id]'));
    if (mediaItems.length < 2) return;

    gallery.dataset.hhDesktopGalleryNav = 'true';

    const nav = document.createElement('div');
    nav.className = 'hh-product-gallery-nav';
    nav.setAttribute('aria-label', 'Product image navigation');

    const previousButton = createButton('previous');
    const nextButton = createButton('next');
    nav.append(previousButton, nextButton);
    viewer.appendChild(nav);

    const navigate = (direction) => {
      if (!desktopQuery.matches) return;

      const currentItems = Array.from(viewer.querySelectorAll('[data-media-id]'));
      if (currentItems.length < 2) return;

      let activeIndex = currentItems.findIndex((item) => item.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      const increment = direction === 'next' ? 1 : -1;
      const nextIndex = (activeIndex + increment + currentItems.length) % currentItems.length;
      const nextMedia = currentItems[nextIndex];

      if (nextMedia && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(nextMedia.dataset.mediaId, false);
      }
    };

    previousButton.addEventListener('click', () => navigate('previous'));
    nextButton.addEventListener('click', () => navigate('next'));
  };

  const initializeAll = (root = document) => {
    if (root.matches?.('media-gallery')) initializeGallery(root);
    root.querySelectorAll?.('media-gallery').forEach(initializeGallery);
  };

  initializeAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  }

  const MediaGalleryElement = customElements.get('media-gallery');
  if (MediaGalleryElement && !MediaGalleryElement.prototype.hhDesktopGalleryNavPatched) {
    const originalConnectedCallback = MediaGalleryElement.prototype.connectedCallback;
    MediaGalleryElement.prototype.connectedCallback = function () {
      if (originalConnectedCallback) originalConnectedCallback.call(this);
      initializeGallery(this);
    };
    MediaGalleryElement.prototype.hhDesktopGalleryNavPatched = true;
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
